module.exports = __webpack_public_path__ + "img/3 titulo portada.99c33e10.svg";